<template>
    <v-content
        class="ma-0 pa-0"
    >
    <!-- THIS FILE ISN'T USED ANYMORE - REPLACED BY SIGNUP PROCESS ON sIGNuP.vue VIEW -->
        <v-card
            outlined
            class="ma-0 pb-5"
        >
            <v-card-title
                class="headline"
                justify="center"
            >
                Create Account
            </v-card-title>
            <v-row
                no-gutters
            >
                <v-text-field
                    v-model="email"
                    label="Email"
                    outlined
                    hide-details
                    class="px-5 mt-5 mb-0 py-0"
                    @keydown.enter="signUp"
                />
            </v-row>
            <v-card
                outlined
                class="mx-5 my-5 pb-5"
            >
                <v-row
                    no-gutters
                >
                    <v-text-field
                        v-model="password1"
                        label="Password"
                        outlined
                        hide-details
                        type="password"
                        class="px-5 mt-5 mb-0 py-0"
                        @keydown.enter="signUp"
                    />
                </v-row>
                <v-row
                    no-gutters
                >
                    <v-text-field
                        v-model="password2"
                        label="Confirm Password"
                        outlined
                        hide-details
                        type="password"
                        class="px-5 mt-5 mb-0 py-0"
                        @keydown.enter="signUp"
                    />
                </v-row>
            </v-card>
            <v-row
                no-gutters
                align="center"
                class="mt-5"
            >
                <v-col
                    class="ml-5 body-2"
                >
                    <a
                        @click.prevent="signIn"
                    >
                        Sign In
                    </a>
                </v-col>
                <v-col
                    class="text-right mr-5 mb-0 pa-0"
                >
                    <v-btn
                        color="info"
                        @click.prevent="signUp"
                        :disabled="disableCreate"
                    >
                        Create
                    </v-btn>
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-right mt-1 pt-0 mx-5 red--text caption"
                >
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage1}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage2}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage3}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-content>
</template>

<script>
    import { Auth } from 'aws-amplify'

    export default {
        data: () => ({
            showPassword: false,
            email: null,
            password1: null,
            password2: null,
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
        }),

        methods: {
            signIn: function() {
                this.$store.dispatch('login/currentAuthView','SignIn'); 
            },

            signUp: function() {
                this.errorMessage1 = null;
                this.errorMessage2 = null;
                this.errorMessage3 = null;
                
                if (this.password1 != this.password2) {
                    this.errorMessage1 = "Passwords do not match"
                }
                
                if (this.password1.length < 6 | this.password2.length < 6) {
                    this.errorMessage2 = "Password must be at least 6 characters"
                }

                if (this.errorMessage1 == null && this.errorMessage2 == null) {
                    Auth.signUp({
                        username: this.email,
                        password: this.password1,
                        attributes: {
                            'email': this.email,
                            'custom:status': 'new',
                        }
                    }).then(user => {
                        console.log(user);
                        this.$router.push('/menu');
                        this.errorMessage1 = null;
                        this.errorMessage2 = null;
                        this.errorMessage3 = null;
                        this.$store.dispatch('login/updateUsername',this.email);
                        this.$store.dispatch('data/createSQLAccount',this.email);
                        this.$store.dispatch('login/newUserCreated');
                    })
                    .catch(error => {
                        console.log(error);
                        if(error.message == 'Invalid email address format.'){
                            this.errorMessage3 = 'Invalid email address'
                        } else {
                            this.errorMessage3 = error.message;
                        }
                    }); 
                }
            },

        },

        computed: {
            disableCreate() {
                if(this.email == null | this.email == '' | this.password1 == null | this.password1 == '' | this.password2 == null | this.password2 == '') {
                    return true
                } else {
                    return false
                }
            },
        }

    }
</script>

<style scoped>
  a {
    color: blue !important;
    text-decoration: underline;
  }
</style>